
import SimpleLightbox from "simplelightbox"

var lightbox = new SimpleLightbox('.app-block-work a', { overlayOpacity: 0.9 });


